














import AbpBase from "@/lib/abpbase"
import {Component, Prop} from "vue-property-decorator"
import Weight from './weight.vue'
import Blood from './blood.vue'
import DialysisSummary from './dialysisSummary.vue'

@Component({
	components: {Weight, Blood, DialysisSummary}
})
export default class XX extends AbpBase {
	@Prop() patient: any
	position = '透析体重统计'

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/treatmentAnalysis/index.vue